const part = [
    {
        path: 'role-management-list',
        name: 'role-management-list',
        meta: {
            icon: 'md-people',
            title: '角色管理',
            notCache: true,
            access: ['S'],
            items: [
            ]
        },
        component: () => import('@/view/system-management/project-management/role-list-page')
    },
    {
	    path: 'role-dept-management-list',
	    name: 'role-dept-management-list',
	    meta: {
	        icon: 'md-people',
	        title: '角色部门管理',
	        notCache: true,
	        access: ['S'],
	        items: [
	        ]
	    },
	    component: () => import('@/view/system-management/project-management/role-dept-list-page')
    },
    {
	    path: 'dept-member-management-list',
	    name: 'dept-member-management-list',
	    meta: {
	        icon: 'md-people',
	        title: '部门成员管理',
	        notCache: true,
	        access: ['S'],
	        items: [
	        ]
	    },
	    component: () => import('@/view/system-management/project-management/dept-member-list-page')
    }
];

export default part;
